import { useParams } from "react-router-dom";
import Navbar from "../../components/Layout/Navbar";
import Footer from "../../components/Layout/Footer";

import EventHeader from "../../components/EventDetail/EventHeader";
import EventContent from "../../components/EventDetail/EventContent";
import EventTabs from "../../components/EventDetail/EventTabs";

import { useEventDetail } from "../../hooks/useEventDetail";

function EventDetail() {
  const { slug } = useParams();
  const { event, loading, error } = useEventDetail(slug);

  return (
    <>
      <Navbar />

      <div className="container mx-auto px-20">
        <div className="mt-6 mb-12">
          {loading ? (
            <p className="text-gray-500">Loading event...</p>
          ) : error && !event ? (
            <p className="text-gray-500">Error loading event: {error}</p>
          ) : !event ? (
            <p className="text-gray-500">Event not found</p>
          ) : (
            <>
              <EventHeader event={event} />
              <EventContent event={event} />
              <EventTabs event={event} />
            </>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default EventDetail;
